import { FulfilmentStatus } from "../../dtos/FulfilmentStatus";

export interface TaxPayer {
    name: string;
    taxId: string;
    firstName?: string;
    lastName?: string;
}

export interface FulfilmentDTO {
    id: string;
    taxpayer: TaxPayer;
    taxPayerPosition?: number;
    delegationPosition?: number;
    taxPayerPath?: string;
    protocol?: string;
    status: FulfilmentStatus;
    amount?: string;
    outcomeTypes?: string[];
    isRevocable: boolean;
    revoked?: boolean | undefined;
}

export enum OutcomeTypePrefix {
    F24 = "F24",
    I24 = "I24",
    G24 = "G24",
    IVP = "IVP",
    CIR = "CIR",
    CLR = "CLR",
    CMR = "CMR",
    RLI = "RLI",
}
